module.exports = __webpack_public_path__ + "img/flowers-8175044_1280.1671c09f.png";